/**
 * A helpful little object that manages flilter-options
 * toggles, assuming that the toggles are written to the
 * filter-options spec.
 *
 * @author Scott V <scottv@ifixit.com>
 */
export var FilterManager = (window.FilterManager = (function() {
   var FilterManager = function(container, options) {
      this.container = container;
      this.enforce = options.enforce;
      this.options = this.container.getChildren('.filter-items > a[data-option]');
      this.options.each(
         function(option) {
            option.addEvent(
               'click',
               function(ev) {
                  this.optionClicked(ev.target);
               }.bind(this)
            );
            // If the option is marked as active when we init,
            // consider it the currently selected option.
            if (option.hasClass('filter-option-active')) {
               this.selected = option;
            }
         }.bind(this)
      );
   };
   FilterManager.prototype = {
      optionClicked: function(option) {
         // Remove the active state from the old selection
         this.selected.removeClass('filter-option-active');
         // Add the active state to the selected one.
         option.addClass('filter-option-active');
         // Update our internal selected state
         this.selected = option;
         // Call our user-provided enforce function
         this.enforce(option);
      },
      // A helper to refresh the UI. Useful when other code on the page
      // may add or remove elements and we need to keep the UI in sync.
      refresh: function() {
         this.enforce(this.selected);
      },
   };
   return FilterManager;
})());
